<script setup lang="ts">
import CheckboxField from '@/components/Fields/CheckboxField.vue'
import StackLayout from '@/components/Layouts/StackLayout.vue'
import { type AdvancedEventFilters } from '@/types/filters/EventFilters'

type Props = {
    filters: Partial<AdvancedEventFilters>
    hasErrors?: Partial<{
        period: boolean
        field: boolean
    }>
}
defineProps<Props>()
type Emits = {
    (e: 'change', filters: Partial<AdvancedEventFilters>): void
}
defineEmits<Emits>()
</script>

<template>
    <StackLayout direction="column" :gap="8">
        <CheckboxField
            :label="$t('event.filters.showFinished')"
            :value="!!filters.finished"
            @click="$emit('change', { finished: $event ? 1 : 0 })" />
        <CheckboxField
            :label="$t('event.filters.showOngoing')"
            :value="!!filters.ongoing"
            @click="$emit('change', { ongoing: $event ? 1 : 0 })" />
        <CheckboxField
            :label="$t('event.filters.showUpcoming')"
            :value="!!filters.upcoming"
            @click="$emit('change', { upcoming: $event ? 1 : 0 })" />
    </StackLayout>
</template>
